import API from '../../../../../API/API'
import { asArray, asText, authHeaders, toSelectOptions } from '../apiHelpers'

/**
 * Note the inversion, which matches the live endpoints: the ERP method list comes
 * from .../{resource}-methods/target and the eCommerce list from .../-methods/source.
 * Keep it as-is - swapping these swaps both dropdowns.
 */
const ERP_METHODS_SEGMENT = 'target'
const ECOMMERCE_METHODS_SEGMENT = 'source'

const methodsUrl = (resource, connectorId, instancesId, segment) =>
    `/Connection/${connectorId}/instance/${instancesId}/${resource}-methods/${segment}`

const mappingsUrl = (resource, connectorId, instancesId) =>
    `/Connection/${connectorId}/instance/${instancesId}/${resource}-mappings`

export const getErpMethods = (resource, connectorId, instancesId, config) =>
    API.get(methodsUrl(resource, connectorId, instancesId, ERP_METHODS_SEGMENT), { headers: authHeaders(), ...config })
        .then((response) => toSelectOptions(response.data))

export const getEcommerceMethods = (resource, connectorId, instancesId, config) =>
    API.get(methodsUrl(resource, connectorId, instancesId, ECOMMERCE_METHODS_SEGMENT), { headers: authHeaders(), ...config })
        .then((response) => toSelectOptions(response.data))

export const getMethodMappings = (resource, connectorId, instancesId, config) =>
    API.get(mappingsUrl(resource, connectorId, instancesId), { headers: authHeaders(), ...config })
        .then((response) => asArray(response.data).map((mapping) => ({
            erpMethod: asText(mapping.erpMethod),
            ecommerceMethod: asText(mapping.ecommerceMethod),
            isEcommerceDefault: Boolean(mapping.isEcommerceDefault),
            isErpDefault: Boolean(mapping.isErpDefault)
        })))

/** Payload shape expected by POST .../{resource}-mappings. */
const toRequestBody = (mapping) => ({
    ecommerceMethod: mapping.ecommerceMethod,
    erpMethod: mapping.erpMethod,
    isEcommerceDefault: mapping.isEcommerceDefault,
    isErpDefault: mapping.isErpDefault
})

export const saveMethodMappings = (resource, connectorId, instancesId, mappings) =>
    API.post(
        mappingsUrl(resource, connectorId, instancesId),
        mappings.map(toRequestBody),
        { headers: authHeaders() }
    ).then((response) => response.data)
